import { useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { isUnauthorized, onUnauthorized } from "./api/client";
import { useMe } from "./api/queries";
import SignIn from "./components/SignIn";
import Spinner from "./components/Spinner";
import { ToastHost } from "./util/toast";
import Dashboard from "./views/Dashboard";
import TreeEditorPage from "./views/TreeEditorPage";

export default function App() {
    const [sessionLost, setSessionLost] = useState(false);
    useEffect(() => onUnauthorized(() => setSessionLost(true)), []);
    const me = useMe();

    if (sessionLost || isUnauthorized(me.error)) return <SignIn />;
    if (me.isPending) return <Spinner label="Loading…" />;
    if (me.isError || !me.data) {
        return (
            <div className="app">
                <div className="empty">
                    Failed to load session: {me.error instanceof Error ? me.error.message : "unknown error"}{" "}
                    <button className="btn" onClick={() => void me.refetch()}>
                        Retry
                    </button>
                </div>
            </div>
        );
    }

    return (
        <>
            <Routes>
                <Route path="/" element={<Dashboard me={me.data} />} />
                <Route path="/env/:envKey" element={<Dashboard me={me.data} />} />
                <Route path="/tree/edit" element={<TreeEditorPage me={me.data} />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <ToastHost />
        </>
    );
}
